const Footer = ({ left, right, secondary }) => (
  <div className="sticky bottom-0 flex flex-row items-center px-10 py-6 mt-auto bg-white border-t border-gray-200">
    {left && <div className="mr-auto">{left}</div>}
    <div className="flex flex-row items-center ml-auto">
      {secondary && (
        <div className="flex">
          {secondary}
          <div className="mx-6 border-r border-gray-200"></div>
        </div>
      )}

      <div className="flex items-center space-x-3">{right}</div>
    </div>
  </div>
);

Footer.propTypes = {
  left: PropTypes.node,
  right: PropTypes.node.isRequired,
  secondary: PropTypes.node,
  classes: PropTypes.object,
};

export default Footer;
